import { Controller } from "@hotwired/stimulus"

import { getDocument, GlobalWorkerOptions } from "pdfjs-dist/legacy/build/pdf.min.mjs";
// import pdfjsWorker from "pdfjs-dist/legacy/build/pdf.worker.mjs";

export default class extends Controller {
  static targets = ["canvas", "pageNumber", "spinner"]
  static values = { url: String }

  currentPage = 1
  pdf = null

  connect() {
    console.log("Controller connected");
    // GlobalWorkerOptions.workerSrc = pdfjsWorker;
    // GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.9.155/pdf.worker.mjs';
    GlobalWorkerOptions.workerSrc = '/vendor/pdfjs/pdf.worker.js';
    if (typeof Worker === 'undefined') {
      alert('您的系统版本过低，无法显示 PDF');
      return;
    }
    this.loadPdf()
  }

  async loadPdf() {
    this.spinnerTarget.classList.remove('hidden')
    const loadingTask = getDocument({
      url: this.urlValue,
      // cMapUrl: "https://cdn.jsdelivr.net/npm/pdfjs-dist@4.9.155/cmaps/",
      cMapUrl: "/vendor/pdfjs/cmaps/",
      cMapPacked: true,
      disableFontFace: false,
      useSystemFonts: true
    });
    this.pdf = await loadingTask.promise
    this.pageNumberTarget.value = this.currentPage
    await this.renderPage()
    this.spinnerTarget.classList.add('hidden')
  }

  async renderPage() {
    if (!this.pdf) {
      console.error("PDF not loaded yet");
      return;
    }

    this.spinnerTarget.classList.remove('hidden')
    try {
      console.log("Starting to render page", this.currentPage);

      const page = await this.pdf.getPage(this.currentPage);
      const canvas = this.canvasTarget;
      const context = canvas.getContext("2d");

      // 根据设备类型和屏幕宽度调整基础缩放因子
      const isMobile = window.innerWidth <= 768;
      const BASE_SCALE = isMobile ? 3.0 : 2.0; // 移动设备使用更高的缩放因子
      const devicePixelRatio = window.devicePixelRatio || 1;

      // 获取容器宽度
      const containerWidth = canvas.parentElement.clientWidth;

      // 计算实际需要的宽度（考虑更高的基础缩放和设备像素比）
      const desiredWidth = containerWidth * BASE_SCALE * devicePixelRatio;

      // 计算缩放比例
      const viewport = page.getViewport({ scale: 1.0 });
      const scale = desiredWidth / viewport.width;
      const scaledViewport = page.getViewport({ scale });

      // 设置canvas的实际渲染尺寸
      canvas.width = scaledViewport.width;
      canvas.height = scaledViewport.height;

      // 使用 CSS transform 进行缩放，可能提供更好的渲染质量
      canvas.style.width = `${containerWidth}px`;
      canvas.style.height = `${(containerWidth * scaledViewport.height) / scaledViewport.width}px`;
      canvas.style.transform = 'translate3d(0,0,0)'; // 启用硬件加速

      // 添加字体加载事件监听
      page.getTextContent().then(function(textContent) {
        console.log('Text content:', textContent);
      }).catch(function(error) {
        console.error('Error getting text content:', error);
      });

      console.log("Starting page render");
      const renderContext = {
        canvasContext: context,
        viewport: scaledViewport,
        enableWebGL: true,
        renderInteractiveForms: true,
        antialiasing: true,
        textLayerMode: 1,
        enhanceTextSelection: true
      };
      const renderTask = page.render(renderContext);
      await renderTask.promise;
      console.log("Page rendered successfully");
    } catch (error) {
      console.error("Error rendering page:", error);
      console.error("Stack:", error.stack);
    } finally {
      this.spinnerTarget.classList.add('hidden')
    }
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.pageNumberTarget.value = this.currentPage;
      this.renderPage();
    }
  }

  nextPage() {
    if (this.pdf && this.currentPage < this.pdf.numPages) {
      this.currentPage++;
      this.pageNumberTarget.value = this.currentPage;
      this.renderPage();
    }
  }

  changePage() {
    const pageNumber = parseInt(this.pageNumberTarget.value, 10);
    if (this.pdf && pageNumber > 0 && pageNumber <= this.pdf.numPages) {
      this.currentPage = pageNumber;
      this.renderPage();
    } else {
      this.pageNumberTarget.value = this.currentPage;
    }
  }
}

